import React from 'react';

export const Catalogue = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M2.59961 4.07687C2.59967 3.36946 3.31484 2.88543 3.97168 3.14816L15.7998 7.87961V30.9196L3.22852 25.8913C2.8489 25.7394 2.59961 25.3715 2.59961 24.9626V4.07687Z'
                fill='currentColor'
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M30.0283 3.14816C30.6852 2.88543 31.4003 3.36945 31.4004 4.07687V24.9626C31.4004 25.3715 31.1511 25.7394 30.7715 25.8913L18.2002 30.9196V7.87961L30.0283 3.14816ZM28.6992 13.1306C28.497 12.6167 27.9163 12.3639 27.4023 12.5661L20.3311 15.3493C19.8172 15.5515 19.5645 16.1314 19.7666 16.6452L19.9131 17.0183C20.1155 17.5318 20.6953 17.7838 21.209 17.5818L28.2812 14.7995C28.7952 14.5973 29.0479 14.0166 28.8457 13.5027L28.6992 13.1306ZM28.6992 8.33078C28.497 7.81685 27.9163 7.5641 27.4023 7.76633L20.3311 10.5486C19.8172 10.7508 19.5644 11.3315 19.7666 11.8454L19.9131 12.2175C20.1153 12.7314 20.6951 12.984 21.209 12.782L28.2812 9.99973C28.7952 9.7975 29.0479 9.21678 28.8457 8.70285L28.6992 8.33078Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Catalogue;
